<template>
  <div id="base-info">
    <div class="header">
      <div class="left">
        <img :src="userInfo.headImgUrl" class="avatar" />
      </div>
      <div class="right">
        <p>手机号：{{ userInfo.mobile }}</p>
        <p>积 分：{{ userInfo.currentScore }}</p>
      </div>
    </div>
    <div class="form">
      <ul>
        <li>
          <p>姓名：</p>
          <input type="text" v-model="name" />
        </li>
        <li>
          <p>车牌号：</p>
          <input type="text" v-model="code" />
        </li>
      </ul>
      <div class="btn">
        <mt-button size="large" type="primary" @click="addBaseInfo"
          >保存</mt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      name: "",
      code: "",
    };
  },
  mounted() {
    this.name = this.userInfo.driverName;
    this.code = this.userInfo.carNum;
  },
  methods: {
    //基础信息完善
    addBaseInfo() {
      if (this.name === "") {
        this.$toast({
          message: "请输入姓名",
          duration: 1800,
        });
        return;
      }
      if (this.code === "") {
        this.$toast({
          message: "请输入车牌号",
          duration: 1800,
        });
        return;
      }
      this.post(this.apis.saveBaseInfo, {
        cardNum: this.code,
        driverName: this.name,
        memberId: this.userInfo.memberId,
      })
        .then((response) => {
          this.$toast({
            message: response.data.retMsg,
            duration: 900,
          });
          if (response.data.retCode == "SUCCESS") {
            setTimeout(() => {
              this.changeRouter("/my");
            }, 900);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>
<style lang="less" scoped>
#base-info {
  .header {
    height: 216px;
    border-bottom: 13px solid #f5f5f5;
    padding: 0 58px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      flex: 0 0 190px;
      .avatar {
        width: 140px;
        height: 140px;
        background-color: pink;
        border-radius: 50%;
      }
    }
    .right {
      flex: 1;
      p {
        font-family: PingFang-SC-Regular;
        font-size: 26px;
        line-height: 44px;
        letter-spacing: 0px;
        color: #3a3a3a;
      }
    }
  }
  .form {
    padding: 58px;
    ul > li {
      color: #292929;
      font-size: 28px;
      height: 82px;
      border-bottom: 1px solid #c5c5c5;
      display: flex;
      justify-content: space-between;
      align-items: center;
      input {
        text-align: right;
        height: 76px;
        border: none;
        outline: none;
      }
    }
  }
  .form {
    .btn {
      margin-top: 62px;
      .green {
        padding-top: 30px;
        text-align: center;
        font-size: 26px;
      }
    }
  }
}
</style>
